import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';

import { CiStatus } from '../../../basics/enums/maya.enums';
import GridListAction from '../../GridListAction/GridListAction';

const useCiAdminDashboardListConfig = (
  editCiCallback: (ciId: string) => void,
  duplicateCiCallback: (ciId: string) => void,
  addChildAction: (ciId: string) => void,
  openModalCallback: (ciId: string) => void,
  syncCiCallback: (ciId: string) => void,
  approveCiCallback: (ciId: string) => void,
) => {
  const { t } = useTranslation();
  const flags = useFlags();

  const ciTitleFieldConfig = {
    label: t('maya_ci_form_ci_title_label'),
    name: 'name',
    placeholder: t('maya_ci_form_ci_title_placeholder'),
    defaultValue: '',
    required: false,
  };

  const customerInitiativeListColumnConfig: GridColDef[] = [
    {
      field: 'title',
      headerName: t('maya_ci_dashboard_title'),
      flex: 0.8,
      sortable: false,
      cellClassName: 'gridlist-cell-bold',
    },
    {
      field: 'action',
      headerName: '',
      disableColumnMenu: true,
      hideSortIcons: true,
      renderCell: (params: GridRenderCellParams) => {
        const actions = [
          {
            label: t('actions_edit_label'),
            callback: () => { editCiCallback(params.row._id); },
          },
          {
            label: t('actions_duplicate_label'),
            callback: () => { duplicateCiCallback(params.row._id); },
          },
          {
            label: t('maya_customer_initiative_list_add_child_cep'),
            callback: () => {
              addChildAction(params.row._id);
            },
          },
        ];

        if (flags.mayaBiogenlinc3810EnableCiDeleting && params?.row?.status !== CiStatus.ACTIVE) {
          actions.splice(2, 0, {
            label: t('maya_action_delete_ci_label'),
            callback: () => {
              openModalCallback(params.row._id);
            },
          });
        }

        if (flags.mayaBiogenlinc2489VeevaSyncButtons && params.row.status !== CiStatus.ACTIVE) {
          actions.push({
            label: t('maya_action_sync_ci_label'),
            callback: () => {
              syncCiCallback(params.row._id);
            },
          });
        }

        if (flags.mayaBiogenlinc5411DisplayActivateCiCta && params.row.status !== CiStatus.ACTIVE) {
          actions.push({
            label: t('maya_action_activate_ci_label'),
            callback: () => {
              approveCiCallback(params.row._id);
            },
          });
        }

        return (
          <GridListAction
            actions={ actions }
          />
        );
      },
      align: 'right',
      headerAlign: 'right',
      flex: 0.1,
      sortable: false,
    },
  ];

  return {
    customerInitiativeListColumnConfig,
    ciTitleFieldConfig,
  };
};

export default useCiAdminDashboardListConfig;
